<template>
<div class="l-footer">
  <Text className="c-text__s" text="© Works Thumbnail Generator"></Text>
</div>
</template>

<script>
import Text from '@/components/atoms/Text'

export default {
  components: {
    Text
  }
}
</script>

<style lang="scss" scoped>
.l-footer{
  width: 100%;
  height: 60px;
  margin-top: 70px;
  background: $color_white_dark;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
